import {
  CreditCard,
  List,
  PeopleOutline,
  PieChartOutlined,
  SendOutlined,
} from "@mui/icons-material";
import React from "react";
import { TranslationKey } from "../components/IntlMessages/IntlMessages";
import { RoutePath } from "./route-path";

export type MenuItem = {
  id: string;
  icon?: React.ReactNode;
  label: TranslationKey;
  route: RoutePath;
};

const CREDENTIALS: MenuItem = {
  id: "credentials",
  icon: <CreditCard />,
  label: "credentials",
  route: RoutePath.CREDENTIALS,
};
const DASHBOARD: MenuItem = {
  id: "dashboard",
  icon: <PieChartOutlined />,
  label: "dashboard",
  route: RoutePath.DASHBOARD,
};
const SHARING: MenuItem = {
  id: "sharing",
  icon: <SendOutlined sx={{ transform: "rotate(320deg)" }} />,
  label: "sharing",
  route: RoutePath.PROOFS,
};
const SHARING_REQUEST: MenuItem = {
  id: "sharing",
  icon: <SendOutlined sx={{ transform: "rotate(320deg)" }} />,
  label: "sharing",
  route: RoutePath.REQUESTS,
};
const SCHEMAS: MenuItem = {
  id: "schemas",
  icon: <List />,
  label: "configurationOption",
  route: RoutePath.SCHEMAS,
};
const USERS: MenuItem = {
  id: "users",
  icon: <PeopleOutline />,
  label: "users",
  route: RoutePath.USERS,
};

export const ALL_MENU_ITEMS = [SCHEMAS, CREDENTIALS, SHARING, USERS];

export const MENU_ITEMS_WITHOUT_OIDC = [SCHEMAS, CREDENTIALS, USERS];

export const MENU_BUSINESS_USER = [SHARING_REQUEST];

export const DASHBOARD_MENU_ITEM = DASHBOARD;
